import {makeAutoObservable} from "mobx";
import {api} from "../../api";
import {debounce} from "../../utils";
import {CustomerDetailDto} from "../../api/cms";


interface GetCustomerProps {
    customerId: string
    callback: (history: CustomerDetailDto) => void
}

const getCustomer = debounce(async ({
                                       customerId, callback
                                   }: GetCustomerProps) => {
    const response = await api.cms.api.getCustomer(customerId)
    callback(response.data)
}, 1000)

class CustomerStore {
    get data(): CustomerDetailDto | undefined {
        return this._data;
    }

    private set data(value: CustomerDetailDto | undefined) {
        this._data = value;
    }

    get customerId(): string | undefined {
        return this._customerId;
    }

    private set customerId(value: string | undefined) {
        this._customerId = value;
    }

    get loading(): boolean {
        return this._loading;
    }

    private set loading(value: boolean) {
        this._loading = value;
    }

    private _data: CustomerDetailDto | undefined
    private _customerId: string | undefined = undefined
    private _loading: boolean = false

    constructor(customerId: string | undefined) {
        makeAutoObservable(this)
        this.customerId = customerId
        this.load().finally()
    }

    private async load() {
        this.loading = true
        const {
            customerId,
        } = this

        if (customerId) {
            getCustomer({
                customerId: customerId,
                callback: (data: CustomerDetailDto)=> {
                    this.data = data
                    this.loading = false
                }
            })
        } else {
            this.data = undefined
            this.loading = false
        }
    }
}

export {
    CustomerStore
}
